module.exports = __webpack_public_path__ + "media/images/features/support/badge-mv-40faddb3fdf9cc3bbde1516a329b97b8.svg";